import React from "react";
import styles from "../styles/RangeSlider.module.css";

const RangeSlider = ({ percent }) => {
  const getBarStyle = () => {
    return {
      left: `${percent}%`,
    };
  };

  return (
    <>
      <div className={styles.rangeSlider}>
        <div className={styles.sliderBar} style={getBarStyle()}></div>
      </div>
      <div className={styles.sliderPercent}>{percent}%</div>
    </>
  );
};

export default RangeSlider;
